export const header = document.querySelector('.header');
export const burgerButton = document.querySelector('.burger-btn');
export const closeButton = document.querySelector('.close-btn');
export const closeButtonTablet = document.querySelector('.close-btn-tablet');
export const headerBackdrop = document.querySelector('.overlay');
export const reviewsContainer = document.querySelector('.js-review');
export const containerWthStars = document.querySelector('.review-stars');
export const buttonReviewLeft = document.querySelector('.button-review-left');
export const buttonReviewRight = document.querySelector('.button-review-right');
export const wrapper = document.querySelector('.swiper-wrapper');
export const Nextbtn = document.querySelector('.reviews__btn--next');
export const Prevbtn = document.querySelector('.reviews__btn--prev');
export const paginationE2 = document.querySelector('.reviews__pagination');

export const categoriesListEl = document.querySelector(
  '.furniture-categories__list'
);
export const productsListEl = document.querySelector(
  '.products-grid.furniture-list-js'
);
export const btnLoadMore = document.querySelector('.furniture__load-more');
export const loaderEl = document.querySelector('#loader');

export const modalOverlay = document.querySelector('.prod-modal-overlay');
export const modalWindow = document.querySelector('.prod-modal-window');
export const closeBtn = document.querySelector('.close-modal-btn');
export const overlay = document.querySelector('.modal-overlay');

export const popularListEl = document.querySelector('.popular-products__list');
export const btnPrev = document.querySelector('.popular-products__btn--prev');
export const btnNext = document.querySelector('.popular-products__btn--next');
export const paginationEl = document.querySelector('.popular-products__pagination');

export const furnitureLists = [popularListEl, productsListEl];
